/* ========================= NPM ======================== */
// jQuery
import "./base/_jquery-global.js";

// Popper.js
// import * as Popper from "@popperjs/core";

// Bootstrap modules (add more as needed)
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/collapse.js";
import "bootstrap/js/dist/scrollspy.js";

import scrollJqueryInit from "../lib/page-scroll-effects/js/jquery-2.1.4.js";
import scrollVelocityInit from "../lib/page-scroll-effects/js/velocity.min.js";
import scrollVelocityUiInit from "../lib/page-scroll-effects/js/velocity.ui.min.js";
import scrollMainInit from "../lib/page-scroll-effects/js/main.js";

scrollJqueryInit();
scrollVelocityInit();
scrollVelocityUiInit();
scrollMainInit();

// Hero slider
import heroSliderInit from "../lib/hero-slider/js/main.js";
heroSliderInit();

// Event button interaction
import eventBtnInit from "../lib/event-button-interaction/js/main.js";
eventBtnInit();

import eventsListInit from "./components/_events-list.js";
eventsListInit();

/* ======================== BASE ======================== */
import { utl_setYear } from "./base/_utilities.js";

utl_setYear();

/* ===================== COMPONENTS ===================== */
import ehElementsInit from "./components/_eh-elements.js";
ehElementsInit();

import mobileNavInit from "./components/_mobile-nav.js";
mobileNavInit();

import contactFormInit from "./components/_contact-form.js";
contactFormInit();
